<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Bimestral
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>Turma: {{ gestaoDeAula.turma?.descricao }}</h4>
              <h4>
                Disciplina:
                {{
                  gestaoDeAula.is_polivalencia === 1
                    ? gestaoDeAula.disciplinas.find((d) => d.id == $route.params.disciplinaId)
                        ?.descricao
                    : gestaoDeAula.disciplina.descricao
                }}
              </h4>
              <h4>
                Professor:
                {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
              </h4>
            </v-card-text>
          </v-col>
          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="podeVerPlano"
                  x-small
                  class="ml-1 white--text"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  @click="() => verHistoricoPlanos()"
                >
                  <span>Histórico do lancamento de planos</span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-card>
      </v-col>
      <v-col cols="12 text-center" class="pt-2">
        <template>
          <v-toolbar>
            <v-tabs dark v-model="form.bimestre" background-color="primary" grow>
              <v-tab
                v-for="item of $constants.bimestres"
                :key="item.value"
                @click="handleTabClick(item)"
              >
                <v-badge v-if="form.bimestre === item.value" color="success">
                  {{ item.desc }}
                </v-badge>
                <div v-else>{{ item.desc }}</div>
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </template>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }" v-if="!loadingPlano">
      <form @submit.prevent="handleSubmit(salvarPlanos)" :disabled="submittingForm">
        <v-row>
          <v-col cols="12">
            <ValidationProvider name="Tematica" rules="required" v-slot="{ errors }">
              <e-label>UNIDADES TEMÁTICAS</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].tematica"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Objeto de conhecimento" rules="required" v-slot="{ errors }">
              <e-label>OBJETO DE CONHECIMENTO</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].objeto_conhecimento"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Habilidades" rules="required" v-slot="{ errors }">
              <e-label>HABILIDADES</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].habilidades"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <!-- <v-col cols="12">
            <ValidationProvider name="Habilidades matriz saeb" rules="required" v-slot="{ errors }">
              <e-label>HABILIDADES MATRIZ SAEB</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].habilidades_matriz_saeb"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col> -->
          <v-col cols="12">
            <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
              <e-label>INDICAÇÕES METODOLÓGICAS</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].metodologia"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Referencia PNLD" rules="required" v-slot="{ errors }">
              <e-label>REFERÊNCIA PNLD</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].referencia_pnld"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Referencia PNLD" rules="required" v-slot="{ errors }">
              <e-label>AVALIAÇÕES</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[bimestreAtual].avaliacoes"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-col cols="12" v-if="exibeDescritoresSAEB">
          <v-dialog v-model="dialogs" fullscreen hide-overlay transition="dialog-bottom-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mb-3 mt-5"
                color="blue"
                dark
                v-bind="attrs"
                v-on="on"
                @click="() => procurarHabilidade()"
              >
                INSIRA O CÓDIGO
              </v-btn>
            </template>

            <v-card>
              <v-toolbar dark color="blue">
                <v-btn icon dark @click="dialogs = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>PESQUISA</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-col>
                <v-row>
                  <v-col cols="12">
                    <v-sheet color="white" elevation="1">
                      <div class="py-2 px-4">
                        <v-text-field
                          v-model="search"
                          autofocus
                          v-on:keyup="() => procurarHabilidade()"
                          label="DIGITE O CODIGO!"
                        ></v-text-field>
                      </div>
                    </v-sheet>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6" class="mb-4 mb-md-0">
                    <v-sheet color="white" elevation="1" rounded>
                      <v-lazy>
                        <div class="text-start py-2 px-4 text-button blue white--text">
                          HABILIDADES ENCONTRADAS
                          <v-icon dark right> mdi-magnify </v-icon>
                        </div>
                      </v-lazy>
                      <v-divider></v-divider>

                      <div class="py-2 px-4">
                        <v-skeleton-loader
                          v-if="carregandoHabilidades"
                          class="mx-auto"
                          max-width="auto"
                          type="list-item"
                        ></v-skeleton-loader>

                        <v-list-item
                          class="grey lighten-3 mb-3 pa-2 pa-md-4"
                          v-for="m in objetivosAprendizagem"
                          :key="m.id"
                        >
                          <v-row class="align-center">
                            <v-col cols="8" sm="10" class="d-flex flex-column justify-start">
                              <div class="text-caption text-sm-body-2">
                                <span class="font-alterativa">
                                  [ {{ m.tipo }} ] {{ m.descricao }}
                                </span>
                              </div>
                              <v-chip class="mt-1" color="primary" small>
                                <span class="font-alterativa">
                                  {{ m.disciplina?.descricao || "" }}
                                </span>
                              </v-chip>
                            </v-col>
                            <v-col cols="4" sm="2" class="text-center">
                              <v-btn
                                @click="adicionarHabilidade(m)"
                                class="mx-1"
                                fab
                                dark
                                x-small
                                color="blue"
                              >
                                <v-icon dark small> mdi-plus </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </div>
                    </v-sheet>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-sheet color="white" elevation="1" rounded>
                      <v-lazy>
                        <div class="text-start py-2 px-4 text-button blue white--text">
                          HABILIDADES SELECIONADAS
                          <v-icon dark right> mdi-checkbox-marked-circle </v-icon>
                        </div>
                      </v-lazy>
                      <v-divider></v-divider>

                      <div class="py-2 px-4">
                        <p
                          v-if="!formData[bimestreAtual]?.objeto_aprendizagem?.length"
                          class="text-caption text-sm-body-1"
                        >
                          Nenhuma habilidade selecionada
                        </p>

                        <v-list-item
                          class="grey lighten-3 mb-3 pa-2 pa-md-4"
                          v-for="(m, index) in formData[bimestreAtual]?.objeto_aprendizagem"
                          :key="m.id"
                        >
                          <v-row class="align-center">
                            <v-col cols="2" sm="1" class="text-center">
                              <v-btn
                                @click="deletarHabilidade(index)"
                                class="mx-1"
                                fab
                                dark
                                x-small
                                color="red"
                              >
                                <v-icon dark small> mdi-delete </v-icon>
                              </v-btn>
                            </v-col>
                            <v-col cols="10" sm="11" class="d-flex flex-column justify-start">
                              <div class="text-caption text-sm-body-2">
                                <span class="font-alterativa">
                                  [ {{ m.tipo }} ] {{ m.descricao }}
                                </span>
                              </div>
                              <v-chip class="mt-1" color="primary" small>
                                <span class="font-alterativa">
                                  {{ m.disciplina?.descricao || "" }}
                                </span>
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </div>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </v-dialog>
        </v-col>
        <v-card class="pa-md-4 mt-1" v-if="exibeDescritoresSAEB">
          <label>DESCRITORES SAEB/SAEPI</label>
          <div>
            <v-list>
              <v-divider></v-divider>
              <v-list-item
                class="grey lighten-3 mb-3 pa-md-4"
                v-for="(m, index) in formData[bimestreAtual]?.objeto_aprendizagem"
                :key="index"
              >
                <v-btn @click="deletarHabilidade(index)" class="mx-2" fab dark small color="red">
                  <v-icon dark> mdi-delete </v-icon>
                </v-btn>
                <v-col cols="12" sm="10" class="d-flex flex-column justify-start">
                  [ {{ m.tipo }} ] {{ m.descricao }}
                  <v-row>
                    <v-col>
                      <v-chip class="mt-2" color="primary">
                        {{ m.disciplina?.descricao || "" }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-list-item>
            </v-list>
          </div>
        </v-card>

        <v-col cols="12">
          <v-row>
            <v-btn
              block
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
    <v-row v-else>
      <v-col cols="12">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader
          ><v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader
          ><v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
    <e-drawer-planos-lancados
      v-model="openDrawer"
      :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
      :bimestre="parseInt(form.bimestre, 10)"
      :disciplina_id="disciplina_id"
      @planoRestaurado="loadData"
    />
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  async mounted() {
    this.loadingPlano = true;
    await this.loadData().then(() => {
      this.loadingPlano = false;
    });
  },
  data() {
    return {
      submittingForm: false,
      form: {
        bimestre: 0,
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
        disciplinas: [],
      },
      loadingPlano: true,
      plano_bimestral: [],
      path: null,
      pathsList: [],
      pathAtual: [],
      formData: [],
      selectedTab: 0,
      dialogs: false,
      search: "",
      mensagem: "",
      carregandoHabilidades: false,
      objetivosAprendizagem: [],
      objeto_aprendizagem: [],
      showMessage: false,
      disciplinaAtualPolivalencia: null,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    podeVerPlano() {
      return this.$constants.rolesParaGestores.find(
        (rpg) =>
          rpg.name ===
          this.user.roles.filter((role) => role.name === "super-admin").find((r) => true)?.name
      );
    },
    bimestreAtual() {
      return this.form.bimestre;
    },
    disciplina_id() {
      return parseInt(this.$route.params.disciplinaId, 10);
    },
    gestao_de_aula_id() {
      return parseInt(this.$route.params.gestaoDeAulaId, 10);
    },
    exibeDescritoresSAEB() {
      const { disciplinaId } = this.$route.params;
      const disciplinaAtualPolivalencia = parseInt(disciplinaId, 10);
      const disciplinaAtual = parseInt(this.gestaoDeAula?.disciplina_id, 10);
      const serieAtual = this.gestaoDeAula.turma?.series[0]?.id;

      // Disciplinas 13 14. Português e Matemática
      const disciplinasPermitidas = [13, 14];
      // Séries 5, 8, 12. 2º, 5º e 9º
      const seriesPermitidas = [5, 8, 12];
      const isSerieValida = seriesPermitidas.includes(serieAtual);
      const isDisciplinaValida = disciplinasPermitidas.includes(disciplinaAtual);
      const isDisciplinaPolivalenciaValida = disciplinasPermitidas.includes(
        disciplinaAtualPolivalencia
      );

      return isSerieValida && (isDisciplinaValida || isDisciplinaPolivalenciaValida);
    },
  },
  methods: {
    atualizarPathAtual(bimestre) {
      this.pathAtual = this.formData[bimestre].path;
    },
    async onFileSelected(file) {
      if (file) {
        const { gestaoDeAulaId, disciplinaId } = this.$route.params;

        try {
          const response = await this.$services.planosBimestraisService.planoBimestralPDF(
            gestaoDeAulaId,
            this.bimestreAtual,
            disciplinaId,
            file
          );

          this.pathAtual = response.path;
          this.formData[bimestre].path = response.path;
        } catch (error) {
          this.$handleError(error);
        } finally {
          this.isUploading = false;
        }
      }
    },
    async downloadPlanoBimestral() {
      const { gestaoDeAulaId, disciplinaId } = this.$route.params;
      try {
        await this.$services.planosBimestraisService.planoBimestralDownload(
          gestaoDeAulaId,
          this.bimestreAtual,
          disciplinaId
        );
      } catch (error) {
        this.$handleError(error);
      }
    },
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async createOrUpdate() {
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        const { bimestre } = this.form;
        this.form.bimestre = bimestre;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplina_id;
        await this.$services.planosBimestraisService.createOrUpdate(this.form);
        this.$toast.success("Plano bimestral salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async loadData() {
      const { gestaoDeAulaId, disciplinaId } = this.$route.params;

      try {
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(gestaoDeAulaId);

        this.formData = {};
        this.objeto_aprendizagem = [];

        const response = await this.$services.planosBimestraisService.pegarPlanos(
          gestaoDeAulaId,
          disciplinaId
        );

        const bimestresExistentes = [];

        response.planos.forEach((plano) => {
          this.$set(this.formData, plano.bimestre, { ...plano });
          bimestresExistentes.push(plano.bimestre);
        });

        this.$constants.bimestres.forEach(({ value: bimestre }) => {
          if (!bimestresExistentes.includes(bimestre)) {
            this.$set(this.formData, bimestre, {
              instrutorDisciplinaTurma_id: gestaoDeAulaId,
              disciplina_id: disciplinaId,
              bimestre,
              objeto_aprendizagem: [],
            });
          }
        });

        if (response.planos.length > 0) {
          this.pathsList = response.planos.map((i) => i.path);
          this.pathAtual = this.pathsList[this.bimestreAtual] || null;
        }

        response.habilidades_saeb.forEach((habilidade) => {
          const bimestre = habilidade.bimestre;

          if (!this.formData[bimestre]) {
            this.$set(this.formData, bimestre, { objeto_aprendizagem: [] });
          }

          if (!Array.isArray(this.formData[bimestre].objeto_aprendizagem)) {
            this.$set(this.formData[bimestre], "objeto_aprendizagem", []);
          }

          if (!this.formData[bimestre].objeto_aprendizagem.includes(habilidade.habilidade_saeb)) {
            this.formData[bimestre].objeto_aprendizagem.push(habilidade.habilidade_saeb);
          }
        });

        if (this.gestaoDeAula.disciplinas.length > 0) {
          const disciplina = this.gestaoDeAula.disciplinas.find((i) => i.id === disciplinaId);
          if (disciplina) {
            this.gestaoDeAula.disciplina = disciplina.descricao;
          }
        }

        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
    },
    async reloadPageData() {
      await this.loadData();
    },
    async procurarHabilidade() {
      this.carregandoHabilidades = true;
      if (!this.gestaoDeAula) return;
      const disciplina_id = parseInt(this.$route.params.disciplinaId, 10);

      const turma_id = this.gestaoDeAula.turma_id;
      try {
        const response = await this.$services.objetivosAprendizagem.pesquisarSaeb({
          disciplina_id,
          turma_id,
          search: this.search,
        });
        this.objetivosAprendizagem = response?.data?.data || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoHabilidades = false;
      }
    },
    async adicionarHabilidade(m) {
      if (!Array.isArray(this.formData[this.bimestreAtual].objeto_aprendizagem)) {
        this.$set(this.formData[this.bimestreAtual], "objeto_aprendizagem", []);
      }
      const habilidadeExistente = this.formData[this.bimestreAtual].objeto_aprendizagem.find(
        (o) => o.id === m.id
      );
      if (habilidadeExistente) {
        this.mensagem = "Esta habilidade já foi adicionada para este bimestre!";
        this.showMessage = true;
        return;
      }
      this.formData[this.bimestreAtual].objeto_aprendizagem.push(m);
      this.mensagem = `Habilidade adicionada com sucesso para o ${this.bimestreAtual}!`;
      this.showMessage = true;
    },

    async deletarHabilidade(index) {
      if (!this.formData[this.bimestreAtual]?.objeto_aprendizagem) {
        this.$handleError(error);
        return;
      }

      this.formData[this.bimestreAtual].objeto_aprendizagem.splice(index, 1);

      this.formData = { ...this.formData };

      this.mensagem = "Habilidade deletada com sucesso!";
      this.showMessage = true;
    },
    async handleTabClick(item) {
      if (item.value !== "descriptors") {
        await this.editarPlano(item.value ? item.value : 0);
      }
    },
    shouldDisableDescriptorsTab() {
      const disciplinaAtual = parseInt(this.$route.params.disciplinaId, 10);
      let disciplinaIds = [this.gestaoDeAula?.disciplina?.id];
      const turma = this.gestaoDeAula?.turma;
      const serieId = turma?.series?.[0]?.pivot?.serie_id || null;
      if (this.gestaoDeAula.is_polivalencia === 1) {
        disciplinaIds = this.gestaoDeAula?.disciplinas?.map((d) => d.id) || [];
      }
      const disciplinaPermitida = [13, 14].includes(disciplinaAtual);
      return !disciplinaPermitida || ![5, 8, 9].includes(serieId);
    },

    async editarPlano(bimestre) {
      const { gestaoDeAulaId } = this.$route.params;
      this.$loaderService.open("Carregando dados...");
      try {
        const response = await this.$services.planosBimestraisService.planoBimestral(
          gestaoDeAulaId,
          bimestre,
          this.disciplina_id
        );
        if (response !== "") {
          this.form = response;
          this.$loaderService.close();
          return;
        }
        this.form = {
          bimestre,
        };
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async salvarPlanos() {
      this.$loaderService.open("Carregando dados...");
      try {
        this.formData = Object.values(this.formData).map((item, index) => {
          return {
            ...item,
            instrutorDisciplinaTurma_id: this.gestao_de_aula_id,
            disciplina_id: this.disciplina_id,
            objeto_aprendizagem: (item.objeto_aprendizagem || []).map((obj) => obj?.id),
          };
        });

        await this.$services.planosBimestraisService.salvarPlanos(
          this.formData,
          this.gestao_de_aula_id,
          this.disciplina_id
        );
        await this.loadData();
        this.$toast.success("Planos salvos com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style scoped>
.font-alterativa {
  font-size: 12pt;
  text-align: justify;
}
</style>
